@if (isDemoUser) {
  <a >
    <mat-icon aria-hidden="false" aria-label="icon">check</mat-icon>
  </a>
}

